import { forkJoin, Observable, tap } from 'rxjs';
import { inject, provideAppInitializer } from '@angular/core';
import { LocaleService } from '@services/locale.service';
import { AuthenticationService } from '../services/authentication.service';
import { EnvironmentService } from '../services/environment.service';
import { MixpanelService } from '../services/mixpanel.service';

export const appInitProvider = provideAppInitializer(() => {
  const authenticationService = inject(AuthenticationService);
  const environmentService = inject(EnvironmentService);
  const mixpanelService = inject(MixpanelService);
  const localeService = inject(LocaleService);

  return forkJoin([
    environmentService.init().pipe(
      tap(() => {
        mixpanelService.init();
      }),
    ),
    new Observable((observer) => {
      authenticationService.initUserToken();
      localeService.initLocale();
      observer.next(undefined);
      observer.complete();
    }),
  ]);
});
